import React from "react";

const Cargo = ({ config, renderField, renderSelect }) => {
    const { name, typeId, comment, packType, placesCount, weight, volume, length, height, width } = config;
    return (
        <>
            <div className="form-group">
                <strong>Груз</strong>
            </div>
            {renderField({ ...name, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderSelect({ ...typeId, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...packType, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...placesCount, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...comment, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...weight, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...volume, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...length, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...width, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...height, fieldWrapper: "col-sm-8 col-md-5" })}
        </>
    );
};

export default Cargo;
